module.exports = __webpack_public_path__ + "img/pro_one_3.abfe5736.jpg";